import React from "react";
import { FaTv, FaBolt, FaUtensils, FaCloud, FaCheckCircle } from "react-icons/fa";
import {
  SectionContainer,
  SectionContent,
  SectionHeader,
  SectionPreTitle,
  SectionSubTitle,
  SectionTitle,
} from "../../styles/global.syles";
import {
  LotterDisplayContent,
  TvShowcaseWrapper,
  FeaturesGrid,
  FeatureBox,
} from "./LotteryDisplay.styles";

const LotteryDisplay = () => {
  return (
    <SectionContainer id="display" bg="#ffffff">
      <SectionContent>
        {/* Section header */}
        <SectionHeader>
          <SectionPreTitle>4K Commercial Hardware & Software</SectionPreTitle>
          <SectionTitle>Huge 4K Digital Lottery Display</SectionTitle>
          <SectionSubTitle>
            Broadcast your entire scratcher inventory in ultra-crisp 4K resolution.
            Automate price updates, showcase live multi-million dollar jackpots, and
            run custom in-store promotions side-by-side.
          </SectionSubTitle>
        </SectionHeader>

        {/* Section body */}
        <LotterDisplayContent>
          <TvShowcaseWrapper>
            <div className="tv-ambient-glow" />
            <div className="img">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2Ftv.png?alt=media&token=fbfe6a7d-68eb-4d08-af31-352a67d8c83b"
                loading="lazy"
                alt="Beyond Lottery 4K Display"
              />
            </div>
          </TvShowcaseWrapper>

          <FeaturesGrid>
            <FeatureBox>
              <div className="icon-wrap">
                <FaTv />
              </div>
              <h4>4K High-Res Scratchers</h4>
              <p>Display 30 to 80+ scratchers clearly with high-contrast box numbers and ticket prices.</p>
            </FeatureBox>

            <FeatureBox>
              <div className="icon-wrap">
                <FaBolt />
              </div>
              <h4>Live Jackpot Feeds</h4>
              <p>Automated real-time prize tickers for Powerball, Mega Millions, and State Lottery games.</p>
            </FeatureBox>

            <FeatureBox>
              <div className="icon-wrap">
                <FaUtensils />
              </div>
              <h4>Split-Screen Store Ads</h4>
              <p>Promote your deli items, beverages, snacks, and beer specials on the same screen.</p>
            </FeatureBox>

            <FeatureBox>
              <div className="icon-wrap">
                <FaCloud />
              </div>
              <h4>Cloud Management</h4>
              <p>Update ticket arrangements, pricing, and banners instantly from your phone or PC.</p>
            </FeatureBox>
          </FeaturesGrid>
        </LotterDisplayContent>
      </SectionContent>
    </SectionContainer>
  );
};

export default LotteryDisplay;
